import store from '@/vuex/store';
const removeElement = _element => {
  setTimeout(() => {
    const _parentElement = _element.parentNode;
    if (_parentElement) {
      _parentElement.removeChild(_element);
    }
  });

};
export default {
  buttonAuth: (el, binding) => {
    el.style.opacity = 0;
    const val = binding.value;
    if (!store.state.registerButtonList.map(e => e.permissionFlag).includes(val)) {
      removeElement(el)
    } else {
      el.style.opacity = 1;
    };
  }
};



// WEBPACK FOOTER //
// ./src/utils/directive.js